export default __webpack_public_path__ + "static/media/gallery_02.f45c8b8e.jpg";